import request from '@/common/request'

const CANAL_ALMODE = '00000000-0000-0000-0000-000000000000'
import Almodelogo from '@/assets/almode_256x181.png'

export async function montarUrlAssinadaDeCanalDeVendas(canalDeVendas: any): Promise<any> {
	if (canalDeVendas.id === CANAL_ALMODE) {
		canalDeVendas.imageURL = Almodelogo
		return canalDeVendas
	}
	if (canalDeVendas.imageURL) {
		const nomeDoArquivo = extrairNomeDosDocumentos(canalDeVendas.imageURL)
		let urlAssinada = recuperarUrlDoStorage(nomeDoArquivo)
		if (!urlAssinada) {
			const extensaoDoArquivo = decodeURIComponent(
				nomeDoArquivo.substring(nomeDoArquivo.lastIndexOf('.') + 1),
			)
			try {
				const presignedUrl = await request.post<{ fileName: string; contentType: string }, string>(
					'/pre-signed-url',
					{
						fileName: nomeDoArquivo,
						folderName: "canal-de-vendas-image",
						contentType: extensaoDoArquivo,
						httpMethod: 'GET',
					},
				)
				const match = presignedUrl.match(/[?&]X-Amz-Expires=(\d+)/)
				const expiresIn = match ? parseInt(match[1], 10) : 3600
				salvarUrlNoStorage(nomeDoArquivo, presignedUrl, expiresIn)
				urlAssinada = presignedUrl
			} catch (e) {
				urlAssinada = ''
			}
		}
		canalDeVendas.imageURL = urlAssinada
	}
	return canalDeVendas
}

function extrairNomeDosDocumentos(url: string) {
	const lastSlashIndex = url.lastIndexOf("/")
	return url.substring(lastSlashIndex + 1)
}

function getStorageKey(nomeDoArquivo: string) {
	return `canal-vendas-url-${nomeDoArquivo}`
}

function salvarUrlNoStorage(nomeDoArquivo: string, url: string, expiresIn: number) {
	const data = {
		url,
		expiraEm: Date.now() + expiresIn * 1000,
	}
	localStorage.setItem(getStorageKey(nomeDoArquivo), JSON.stringify(data))
}

function recuperarUrlDoStorage(nomeDoArquivo: string) {
	const raw = localStorage.getItem(getStorageKey(nomeDoArquivo))
	if (!raw) return null
	const data = JSON.parse(raw)
	if (Date.now() < data.expiraEm) {
		return data.url
	}
	return null
}